import React, { useContext } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useHandleOpenViewerClick } from "../../../media-viewer/mediaViewerRedux";
import { getDownloadFileName, useDownloadLink } from "../../../util/mediaUtil";
import { MediaContext } from "../../common/media-context";
import { useIsAdmin, useIsUserIAPManager } from "../../../auth/authUtils";

import CircularProgress from "@mui/material/CircularProgress";
import DownloadIcon from "@mui/icons-material/SaveAlt";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import OpenIcon from "@mui/icons-material/OpenInNewOutlined";
import Tooltip from "@mui/material/Tooltip";

import ContentMediaUpdateAction from "./ContentMediaUpdateAction";
import { anyTrue } from "../../../util/ext";
import { Skeleton } from "@mui/material";

const useStyles = makeStyles(theme => ({
  wrapper: {
    // margin: theme.spacing(1),
    position: "relative",
  },

  loading: {
    position: "absolute",
    top: 2,
    left: 2,
    zIndex: 1,
  },
}));

const DownloadLink = () => {
  const context = useContext(MediaContext);
  const { data: downloadLink, isLoading } = useDownloadLink(context.media);

  if (isLoading) {
    return <Skeleton variant="circular" height={30} width={30} />;
  }

  if (!downloadLink) return null;

  return (
    <Tooltip title="Download">
      <IconButton
        id="download-media"
        aria-label="Download File"
        href={downloadLink}
        target="_blank"
        download={getDownloadFileName(context.media)}
        size="large"
      >
        <DownloadIcon fontSize="large" />
      </IconButton>
    </Tooltip>
  );
};

const ContentMediaActions = props => {
  const classes = useStyles();
  const context = useContext(MediaContext);
  const isAdmin = useIsAdmin();
  const isIAPManager = useIsUserIAPManager();

  const { handleOpenViewerClick, isViewerLoading } = useHandleOpenViewerClick();

  return (
    <Grid container>
      <Grid item>
        <DownloadLink />
      </Grid>
      <Grid item>
        <Tooltip title="View Media">
          <div className={classes.wrapper}>
            <IconButton
              onClick={() => handleOpenViewerClick(context.media)}
              size="large"
            >
              <OpenIcon fontSize="large" />
            </IconButton>
            {isViewerLoading && (
              <CircularProgress className={classes.loading} color="primary" />
            )}
          </div>
        </Tooltip>
      </Grid>
      {anyTrue([isAdmin, isIAPManager]) && (
        <Grid item>
          <ContentMediaUpdateAction media={context.media} />
        </Grid>
      )}
    </Grid>
  );
};

export default ContentMediaActions;
